// extracted by mini-css-extract-plugin
export default {"container":"g9QN8","title":"BaVVd"};